import React, { useState, useEffect } from "react";
import { Modal, Button, ListGroup, Form } from "react-bootstrap";
import { editOrderPrice } from "../../../redux/actions/dbactions/orderActions";
import { useDispatch } from "react-redux";

const EditOrderPrice = ({ order, show, onHide, selectedId }) => {
  const [totalAmount, setTotalAmount] = useState(
    order ? order.order_tot_amt : ""
  );
  const [inputValue, setInputValue] = useState('');

  const dispatch = useDispatch();
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  useEffect(() => {
    setTotalAmount(order ? order.order_tot_amt : "");
  }, [order]);

  const handleSave = () => {
    if (selectedId) {
      dispatch(editOrderPrice(selectedId, totalAmount, inputValue));
    }
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="!text-base font-medium">Edit Price</Modal.Title>
      </Modal.Header>
      <Modal.Body className="!text-sm">
        {order ? (
          <div>
            <div className="flex justify-between mb-3">
              <div className="text-[#26262A]">
                Order ID:{" "}
                <span className="text-[#767676]">{order.order_id}</span>
              </div>
              <div className="text-[rgb(38,38,42)]">
                Order Date:{" "}
                <span className="text-[#767676]">{order.order_dte_tsp}</span>
              </div>
            </div>
            <div>
              <label className="text-[#26262A]">Enter Amount:</label>
              <Form.Control
                type="text"
                value={totalAmount}
                onChange={(e) => setTotalAmount(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="customTextInput">
                <b>Add detailed costs for the amout above:</b>
              </label>
              <textarea
                placeholder="Example: urine test: $80, blood test: $100"
                className="form-control"
                id="customTextInput"
                value={inputValue}
                onChange={handleInputChange}
                rows="4"
                style={{ marginLeft: '10px', padding: '5px', fontSize: '14px', width: '100%' }}
              />
            </div>

            {/* Display svc_order_line details if available */}
            {order.svc_order_line && order.svc_order_line.length > 0 && (
              <>
                <h5>Service Order Lines</h5>
                <ListGroup>
                  {order.svc_order_line.map((line, index) => (
                    <ListGroup.Item key={index}>
                      <div>
                        <strong>Service Name:</strong> {line.svc_name}
                      </div>
                      <div>
                        <strong>Quantity:</strong> {line.svc_qnty_nbr}
                      </div>
                      <div>
                        <strong>Price:</strong> ${line.svc_price_amt}
                      </div>
                      <div>
                        <strong>Status:</strong> {line.svc_status}
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </>
            )}
          </div>
        ) : (
          <p>No order details available.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          className="w-full !rounded-md !max-w-24 !text-sm text-black !bg-white h-[43px] !border-[#E9E9E9]"
        >
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          className="w-full !rounded-md !max-w-24 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditOrderPrice;
